export enum StorageConst {
    ACCESS_TOKEN = 'ACCESS_TOKEN',
    MERCHANT_ID = 'MERCHANT_ID',

}